import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Style } from '@/components/style';

const { gray3Color, blackColor } = new Style().getUiConfig();
function CommentInput({ commentRef }) {
  const intl = useIntl();
  return (
    <div className="d-flex justify-content-center">
      <textarea
        rows={5}
        style={{
          marginTop: '20px',
          width: '100%',
          fontSize: '16px',
          borderRadius: '10px',
          border: `1px solid ${gray3Color}`,
          color: `${blackColor}`,
        }}
        ref={commentRef}
        data-testid="comment"
        id="comment"
        placeholder={intl.formatMessage({
          id: 'welcome.comment',
        })}
        maxLength={1000}
      />
    </div>
  );
}

CommentInput.propTypes = {
  commentRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    .isRequired,
};

export default CommentInput;
